<template>
    <div
        class="sidebar__overlay"
        @click="closesidebar()"
        :class="[{ opened: showSidebar }]"
    ></div>
</template>

<script>
export default {
    props: {
        showSidebar: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        closesidebar() {
            this.$emit('closesidebar');
        },
    },
};
</script>

<style lang="scss">
.sidebar__overlay {
    background-color: rgba(0, 0, 0, 0.55);
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 4;
    width: 100vw;
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.5s;

    &.opened {
        opacity: 1;
        pointer-events: all;
    }
}
</style>
